import * as React from 'react'
import { number, string } from 'prop-types'
import { styled } from '@mui/material/styles'
import { Rating, Stack, Typography } from '@mui/material'

const StyledRating = styled(Rating)(({ theme }) => ({
  width: '100%',
  lineHeight: '22.18px',
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
  '& .MuiRating-iconFilled': {
    color: theme.palette.warning.main,
  },
  [theme.breakpoints.down('md')]: {
    '> span': {
      width: '20%',
      margin: '0 1px',
    },
  },
}))

export default function RATINGS(props) {
  const { label, className } = props
  return (
    <Stack direction="row" alignItems="center" justifyContent="start" className={className}>
      {label && <Typography>{label}</Typography>}
      <StyledRating {...props} />
    </Stack>
  )
}

RATINGS.propTypes = {
  value: number,
  label: string,
  className: string,
}
